"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Questionnaire = exports.CordQuestionService = void 0;
const tslib_1 = require("tslib");
const fetch_client_1 = require("./fetch-client");
class CordQuestionService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordQuestionService.instance) {
      return CordQuestionService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordQuestionService.instance = this;
  }
  getQuestionnaires() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const result = yield this.get(`questionnaires`);
      return result.map(item => {
        var _a;
        // This is required, because sometimes questionnaires can have no name.
        item.Name = (_a = item.Name) !== null && _a !== void 0 ? _a : '';
        if (typeof item.CreatedDate === 'string') {
          item.CreatedDate = new Date(item.CreatedDate);
        }
        item.startQuestionnaire = date => tslib_1.__awaiter(this, void 0, void 0, function* () {
          const instance = new Questionnaire(this, item.Id, date);
          yield instance.init();
          return instance;
        });
        item.openQuestionnaire = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
          const instance = new Questionnaire(this, item.Id);
          yield instance.open();
          return instance;
          // how to use :
          // qs = new CordQuestionService();
          // const list = await qs.getQuestionnaires();
          // const q = await list[0].openQuestionnaire();
          // q.questionnaire.questions[0].answerOptions[0].selectAndSubmit();
        });
        return item;
      });
    });
  }
  getQuestionnaire(questionnaireId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const questionnaires = yield this.getQuestionnaires();
      return questionnaires.find(item => {
        return item.Id === questionnaireId;
      });
    });
  }
  searchQuestionnaireByParam(searchParam) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.post('questionnaire/search', searchParam);
    });
  }
  startQuestionnaireById(questionnaireId, applicationId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const url = `questionnaireresponse/start/${questionnaireId}${applicationId ? `?applicationId=${applicationId}` : ''}`;
      return this.get(url);
    });
  }
  postQuestionnaireAnswer(answer) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.post('answer', answer);
    });
  }
  getAnswersAndScoring(questionnaireId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.get(`questionnaireResponse/${questionnaireId}`);
    });
  }
  getAnswersAndScoringWithDossierId(dossierId, questionnaireId, questionnaireResponseId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.post('questionnaireResponse', {
        DossierId: dossierId,
        QuestionnaireId: questionnaireId,
        QuestionnaireResponseId: questionnaireResponseId
      });
    });
  }
  questionnaireResponseSearch(dateRangeFrom, startDate, dateRangeTo, endDate) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const grapqlBody = {
        query: `{
            questionnaireResponseSearch (${dateRangeFrom}:"${startDate}",${dateRangeTo}:"${endDate}")
            {
                id,
                questionnaireId,
                createdDate,
                questionnaireStartDate,
                scoring,
                answers {
                    questionId,
                    values,
                    updatedDate
                }
            }
          }`
      };
      return yield this.post('GraphQl/search', grapqlBody);
    });
  }
  createQuestionnaire(questionnaire) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.post('questionnaire', questionnaire);
    });
  }
  questionnaireResponseSearchBasic() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const grapqlBody = {
        query: `{
            questionnaireResponseSearch
            {
                id,
                questionnaireId,
                createdDate,
                questionnaireStartDate,
                scoring,
                answers {
                    questionId,
                    values,
                    updatedDate
                }
            }
          }`
      };
      return yield this.post('GraphQl/search', grapqlBody);
    });
  }
  deleteQuestionnaireResponse(questionnaireResponseId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return this.delete(`questionnaireresponse/${questionnaireResponseId}`);
    });
  }
  deleteQuestionnaire(questionnaireId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return this.delete(`questionnaire/${questionnaireId}`);
    });
  }
  archiveQuestionnaire(questionnaireId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.patch(`questionnaireResponse/archive/${questionnaireId}`, null);
    });
  }
  updateQuestionnaire(questionnaireId, modifiedQuestionnaire) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.patch(`questionnaire/${questionnaireId}`, modifiedQuestionnaire);
    });
  }
  getQuestionnaireDetailsById(questionnaireId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      return yield this.get(`questionnaire/${questionnaireId}`);
    });
  }
}
exports.CordQuestionService = CordQuestionService;
CordQuestionService.instance = null;
class Questionnaire {
  constructor(questionService, id, date) {
    this.date = '';
    this.createCustomQuestionnaire = questionnaire => tslib_1.__awaiter(this, void 0, void 0, function* () {
      const result = yield this.questionService.createQuestionnaire(questionnaire);
      return result;
    });
    this.getQuestionnaire = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
      const result = yield this.questionService.get(`questionnaires/${this.questionnaireId}`);
      result.Questions = result.Questions.map(q => {
        q.selectedAnswers = {};
        q.AnswerOptions = q.AnswerOptions.map(a => {
          a.select = text => {
            q.selectedAnswers[a.Id] = text !== null && text !== void 0 ? text : '';
          };
          a.selectAndSubmit = text => {
            a.select(text);
            return q.submit();
          };
          a.deselect = () => {
            delete q.selectedAnswers[a.Id];
          };
          // This method should be deleted. It should only be available on questionnaire level
          a.finish = () => {
            console.warn('Deprecated: Warning this method will be deleted');
            return q.markAsFinished();
          };
          return a;
        });
        q.submit = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
          yield this.questionService.post('answer', {
            QuestionId: q.Id,
            QuestionnaireResponseId: this.QuestionnaireResponseId,
            Answers: q.selectedAnswers
          });
        });
        // This should be deleted. It should only be available on questionnaire level.
        q.markAsFinished = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
          console.warn('Depricated method');
          yield this.questionService.get(`questionnaireResponse/complete/${this.QuestionnaireResponseId}`);
        });
        return q;
      });
      this.questionnaire = result;
    });
    this.getAnswersAndScoring = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
      const responses = yield this.questionService.get(`questionnaireResponse/${this.questionnaireId}`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.history = responses.map(r => {
        r.load = () => {
          this.QuestionnaireResponseId = r.Id;
        };
        return r;
      });
    });
    this.startQuestionnaire = date => tslib_1.__awaiter(this, void 0, void 0, function* () {
      if (date) {
        this.QuestionnaireResponseId = yield this.questionService.get(`questionnaireResponse/start/${this.questionnaireId}/${date}`);
      } else {
        this.QuestionnaireResponseId = yield this.questionService.get(`questionnaireResponse/start/${this.questionnaireId}`);
      }
    });
    // This method should be deleted. It should only be available on answer.
    this.submitAnswer = (questionid, value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
      if (typeof value === 'string') {
        value = [value];
      }
      yield this.questionService.post('answer', {
        QuestionnaireResponseId: this.QuestionnaireResponseId,
        QuestionId: questionid,
        Answers: value
      });
    });
    this.markAsFinished = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
      const scores = yield this.questionService.get(`questionnaireResponse/complete/${this.QuestionnaireResponseId}`);
      const result = Object.keys(scores).map(questionId => {
        return {
          QuestionId: questionId,
          Score: scores[questionId]
        };
      });
      return result;
    });
    this.archive = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
      yield this.questionService.patch(`questionnaireResponse/archive/${this.questionnaireId}`, null);
    });
    this.questionService = questionService;
    this.questionnaireId = id;
    if (date) {
      this.date = date;
    }
  }
  init() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      yield Promise.all([this.getQuestionnaire(), this.getAnswersAndScoring(), this.startQuestionnaire(this.date)]);
    });
  }
  open() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      yield Promise.all([this.getQuestionnaire(), this.getAnswersAndScoring()]);
    });
  }
}
exports.Questionnaire = Questionnaire;
